<!--客户管理-商家信息上传-->
<template>
  <div class="abnormal_data_page">
    <!-- 工具条 -->
    <el-form :inline="true" size="mini">
<!--      <el-form-item>-->
<!--        <el-input-->
<!--          v-model="postdata.LocaleName"-->
<!--          placeholder="监测点"-->
<!--          @clear="searchData"-->
<!--          clearable-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-select
          v-model="postdata.Id"
          filterable
          clearable
          remote
          reserve-keyword
          placeholder="请输入监测点名称"
          :remote-method="remoteMethod"
          @change="searchData">
          <el-option
            v-for="item in localeList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          type="daterange"
          v-model="PanicRangeTime"
          @change="searchData"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="searchData"
          >查询</el-button
        >
        <el-button type="primary" size="mini" @click="handleAdd"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <el-table
      :data="dataObj.list"
      size="mini"
      border
      highlight-current-row
      :max-height="clientHeight"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column type="index" label="#" align="center" width="55" />
      <el-table-column
        prop="LocaleName"
        label="监测点"
        show-overflow-tooltip
        header-align="center"
      />
      <el-table-column
        prop="LocaleAddr"
        label="安装地址"
        show-overflow-tooltip
        header-align="center"
      />
      <el-table-column
        prop="CreatedAt"
        label="提交日期"
        width="180"
        align="center"
      />
      <el-table-column
        prop="UploadType"
        label="上报内容"
        width="200"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.UploadType | typeFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="清洗日期"
        width="180"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.EndDate.split(' ')[0] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="200"
        fixed="right"
        header-align="center"
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="deleteWashInfo(row)" size="mini">删除</el-button>
          <el-button type="text" @click="handleLook(row)" size="mini">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 工具条 -->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="postdata.Page"
        :page-sizes="[20, 40, 100]"
        :page-size="postdata.PerPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="dataObj.total"
      >
      </el-pagination>
    </el-col>
    <!--新增、查看界面-->
    <el-dialog
      :title="dlg.title"
      :visible.sync="dlg.visible"
      @close="handlerClose"
      style="overflow: hidden"
      top="50px"
    >
      <div style="overflow-y: auto; height: 60vh">
        <el-form
        :model="formData"
        label-width="140px"
        :rules="formRule"
        ref="form"
        size="mini"
        :disabled="dlg.title === '查看'"
      >
        <el-form-item prop="LocaleId" label="监测点">
          <template v-if="dlg.title == '查看'">
            <el-input
              placeholder="请输入内容"
              v-model="formData.LocaleName"
              :disabled="true">
            </el-input>
          </template>
          <template v-else>
            <el-select
              v-model="formData.LocaleId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入监测点名称"
              :remote-method="remoteMethod">
              <el-option
                v-for="item in localeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
<!--        <el-form-item label="上报类型" prop="UpWay">-->
<!--          <el-select v-model="formData.UpWay" placeholder="请选择上报类型" @change="changeWashWay">-->
<!--            <el-option label="净化器清洗" value="1"></el-option>-->
<!--            <el-option label="店名更改" value="2"></el-option>-->
<!--            <el-option label="其他" value="3"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        净化器清洗-->
<!--        <div v-if="formData.UpWay === '1'">-->
          <el-form-item prop="UploadType" label="清洗方式">
            <el-select v-model="formData.UploadType" @change="changeWashWay">
              <el-option
                label="第三方清洗"
                value="FilterWash"
              ></el-option>
              <el-option
                label="自主清洗"
                value="Complaint"
              ></el-option>
              <el-option
                label="净化器换新"
                value="BusinessStopped"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="清洗日期" required prop="starDay">
            <el-date-picker
              v-model="formData.starDay"
              >
            </el-date-picker>
          </el-form-item>
          <div v-if="formData.UploadType === 'FilterWash'">
            <el-form-item label="清洗单位" prop="washUnit" >
              <el-input v-model="formData.washUnit" placeholder="请输入清洗单位"></el-input>
            </el-form-item>
            <el-form-item label="清洗前照片" prop="washPer" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListInfo">
                  <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListInfo"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashPerThird"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="upload()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washPer')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>

            </el-form-item>
            <el-form-item label="清洗后照片" prop="washBack" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListBefore">
                  <div class="single-img" v-for="(item, idx) in fileListBefore" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListBefore"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashBackThird"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashBack()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washBack')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washBack')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="其他材料" prop="washOther" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListOther">
                  <div class="single-img" v-for="(item, idx) in fileListOther" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListOther"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <div style="position: absolute;left: -120px;top: 30px;width: 120px;">(清洗合同、清洗报告、收据等其他证明材料)(1-5张)</div>
                <el-upload
                  ref="uploadWashOtherThird"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashOther()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washOther')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washOther')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>

            </el-form-item>
          </div>
          <div v-else-if="formData.UploadType === 'Complaint'">
            <el-form-item label="清洗前照片" prop="washPer" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListInfo">
                  <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListInfo"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashPerSelf"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="upload()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washPer')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="清洗后照片" prop="washBack" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListBefore">
                  <div class="single-img" v-for="(item, idx) in fileListBefore" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListBefore"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashBackSelf"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashBack()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washBack')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washBack')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div v-else-if="formData.UploadType === 'BusinessStopped'">
            <el-form-item label="旧净化器照片" prop="washPer" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListInfo">
                  <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListInfo"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashPerFilter"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="upload()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washPer')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="新净化器照片" prop="washBack" style="position: relative;height: auto">
              <div v-if="dlg.title === '查看'">
                <div class="img-list" v-if="fileListBefore">
                  <div class="single-img" v-for="(item, idx) in fileListBefore" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListBefore"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashBackFilter"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashBack()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washBack')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-delete"
                    @click="removeImg(file, 'washBack')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                  </div>
                </el-upload>
              </div>

            </el-form-item>
          </div>
<!--        </div>-->

<!--        店名更改-->
<!--        <div v-else-if="formData.UpWay === '2'">-->
<!--          <el-form-item label="新店铺名称" prop="newAccountName" >-->
<!--            <el-input v-model="formData.newAccountName" placeholder="请输入新店铺名称"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="门头照片" prop="washPer" style="position: relative">-->
<!--            <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>-->
<!--            <el-upload-->
<!--              ref="uploadWashPerThird"-->
<!--              list-type="picture-card"-->
<!--              accept=".jpg,.jpeg,.png"-->
<!--              :action="upload()"-->
<!--              :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"-->
<!--              :limit="5"-->
<!--            >-->
<!--              <i slot="default" class="el-icon-plus"></i>-->
<!--              <div slot="tip">（支持jpg、jpeg、png）</div>-->
<!--              <div slot="file" slot-scope="{file}">-->
<!--                <img-->
<!--                  class="el-upload-list__item-thumbnail"-->
<!--                  :src="file.url" alt=""-->
<!--                >-->
<!--                <span class="el-upload-list__item-actions">-->
<!--                  <span-->
<!--                    class="el-upload-list__item-delete"-->
<!--                    @click="removeImg(file, 'washPer')">-->
<!--                    <i class="el-icon-delete"></i>-->
<!--                  </span>-->
<!--                </span>-->
<!--              </div>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--        </div>-->

<!--        其他-->
<!--        <div v-else-if="formData.UpWay === '3'">-->
<!--          <el-form-item label="上传图片" prop="washPer" style="position: relative">-->
<!--            <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>-->
<!--            <el-upload-->
<!--              ref="uploadWashPerThird"-->
<!--              list-type="picture-card"-->
<!--              accept=".jpg,.jpeg,.png"-->
<!--              :action="upload()"-->
<!--              :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"-->
<!--              :limit="5"-->
<!--            >-->
<!--              <i slot="default" class="el-icon-plus"></i>-->
<!--              <div slot="tip">（支持jpg、jpeg、png）</div>-->
<!--              <div slot="file" slot-scope="{file}">-->
<!--                <img-->
<!--                  class="el-upload-list__item-thumbnail"-->
<!--                  :src="file.url" alt=""-->
<!--                >-->
<!--                <span class="el-upload-list__item-actions">-->
<!--                  <span-->
<!--                    class="el-upload-list__item-delete"-->
<!--                    @click="removeImg(file, 'washPer')">-->
<!--                    <i class="el-icon-delete"></i>-->
<!--                  </span>-->
<!--                </span>-->
<!--              </div>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--        </div>-->

        <el-form-item prop="Remark" label="备注">
          <el-input v-model.trim="formData.Remark" />
        </el-form-item>

      </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="dlg.title === '新增'" size="mini" @click.native="dlg.visible = false"
          >取消</el-button
        >
        <el-button v-if="dlg.title === '新增'" type="primary" size="mini" @click.native="handleSubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { parseTime } from '@/util/index'
import conf from '@/config'
import Da from "element-ui/src/locale/lang/da";

export default {
  components: {},
  data() {
    return {
      postdata: {
        Page: 1, // 页码，自用
        PerPage: 20, // 页数，自用
        StartAt: 0, // 起始偏移量
        Size: 10, // 每页显示数量
        LocaleName: '', // 监测点名称
        Type: null, // 设备状态 2 // 异常离线；3 // 数据异常偏大；4 // 数据异常偏小；5 // 在线时间短；6 // 数据漂移异常
        OwnerId: [], // 所属单位
        RecordAtStart: '', // 异常日期开始时间
        RecordAtEnd: '', // 异常日期结束时间
        Status: null, // 操作状态 1 // 异常数据 待处理；2 // 异常数据 已派单；3 // 异常数据 正常
        HandleAtStart: '', // 处理日期开始时间
        HandleAtEnd: '' // 处理日期结束时间
      },
      PanicRangeTime: [], // 异常日期时间，自用
      loading: false,
      dataObj: {
        list: []
        // pages: 0,
        // total: 0,
      },
      dlg: {
        visible: false,
        title: ''
      },
      localeList: [],
      fileListInfo: [],//用于查看的时候渲染清洗前的照片（旧净化器）
      fileListBefore: [],//用于查看的时候渲染清洗后的照片（新净化器）
      fileListOther: [],//用于查看的时候渲染清洗其他的材料
      changeState: false,
      formData: {
        UploadType:'FilterWash',//默认清洗方式
        starDay:new Date().toISOString().split('T')[0],
        washUnit:'',//存储清洗单位
        washPer:[],//存储清洗前照片
        washBack:[],//存储清洗后照片
        washOther:[],//存储清洗的其他材料
      },
      formRule: {
        LocaleId: [
          { required: true, message: '请选择监测点', trigger: 'blur' }
        ],
        UpWay: [
          { required: true, message: '请选择上报类型', trigger: 'change' }
        ],
        UploadType: [
          { required: true, message: '请选择清洗方式', trigger: 'change' }
        ],
        starDay: [
          { type: 'date', required: true, message: '请选择清洗日期', trigger: 'change' }
        ],
        washUnit: [
          { required: true, message: '请输入清洗单位', trigger: 'blur' },
        ],
        newAccountName: [
          { required: true, message: '请输入新店铺名称', trigger: 'blur' },
        ],
        washPer: [
          { required: true, message: '请选择上传清洗前图片', trigger: 'blur' }
        ],
        washBack: [
          { required: true, message: '请选择上传清洗后图片', trigger: 'blur' }
        ],
        washOther: [
          { required: true, message: '请选择上传其他材料', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['customerTree','clientHeight']),
    ...mapState({
      customerProps: (state) =>
        Object.assign({}, state.props, { label: 'Org', checkStrictly: true })
    })
  },
  mounted() {
    this.netGetMessageList() // 获取列表
  },
  filters: {
    typeFilter(type) {
      const op = {
        Complaint: '自主清洗',
        FilterWash: '第三方清洗',
        BusinessStopped: '净化器换新'
      }
      return op[type]
    }
  },
  methods: {
    /**
     * @description 日期格式化
     */
    dateFormatter(row, column) {
      return parseTime(row[column.property], '{y}-{m}-{d}')
    },
    remoteMethod(queryString) {
      if (queryString !== '') {
        setTimeout(() => {
          const par = {"StartAt":0,"Size":100,"Param":{"Name":queryString}}
          this.$post('admin/listLocale', par).then((res) => {
            this.localeList = res.content
          }).catch(() => {})
        }, 300);
      } else {
        this.localeList = [];
      }
    },

    /**
     * @description 获取列表
     */
    netGetMessageList() {
      this.loading = true
      const postdata = JSON.parse(JSON.stringify(this.postdata))
      if (this.PanicRangeTime && this.PanicRangeTime.length > 0) {
        postdata.RecordAtStart = this.PanicRangeTime[0]
        postdata.RecordAtEnd = this.PanicRangeTime[1]
      }

      postdata.OwnerId = postdata.OwnerId[postdata.OwnerId.length - 1] * 1

      postdata.StartAt = postdata.perPage * (postdata.page - 1)
      postdata.Size = postdata.perPage

      for (const key in postdata) {
        if (postdata[key] === '') {
          delete postdata[key]
        }
      }
      //这里改用传LocaleId获取清洗记录
      if(postdata.Id){
        postdata.LocaleId = postdata.Id
        delete postdata.Id
      }
      this.$post('admin/queryLocaleUploadedInfo', postdata)
        .then((res) => {
          //console.log(res)
          this.dataObj.list = res.content
          this.dataObj.Page = Math.ceil(res.total / this.postdata.perPage);
          this.dataObj.total = res.total;
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    /**
     * @description 查询
     */
    searchData() {
      this.postdata.Page = 1
      this.netGetMessageList()
    },

    /**
     * @description 每页条数
     */
    handleSizeChange(pageSize) {
      this.postdata.Page = 1
      this.postdata.PerPage = pageSize
      this.netGetMessageList()
    },

    /**
     * @description 页码
     */
    handleCurrentChange(page) {
      this.postdata.Page = page
      this.netGetMessageList()
    },
    //上传清洗前照片
    upload() {
      return conf.uploadApi + '/uploadToOss';
    },
    //上传清洗后照片
    uploadWashBack() {
      return conf.uploadApi + '/uploadToOss';
    },
    //上传清洗其他照片
    uploadWashOther() {
      return conf.uploadApi + '/uploadToOss';
    },
    //图片上传完成时调用
    handleAvatarSuccess(res, file, field) {
      // this.formData[field].push({ url: res.Data });
      this.formData[field].push(res.Data);
    },
    //移除上传的图片
    removeImg(file, field) {
      const uploadRef = this.$refs[`upload${field.charAt(0).toUpperCase() + field.slice(1)}Third`] ||
        this.$refs[`upload${field.charAt(0).toUpperCase() + field.slice(1)}Self`] ||
        this.$refs[`upload${field.charAt(0).toUpperCase() + field.slice(1)}Filter`];
      if (uploadRef) {
        let uploadFile = uploadRef.uploadFiles;
        let index = uploadFile.indexOf(file);
        uploadFile.splice(index, 1);
        this.formData[field].splice(index, 1);
      }
    },

    //清除上传图片的状态
    clearUpload(refName) {
      const uploadRef = this.$refs[refName];
      if (uploadRef) {
        uploadRef.clearFiles();
      }
    },
    //重置输入的数据
    resetRuleForm() {
      this.formData.starDay = new Date(); // 重新设置默认日期
      this.formData.washPer = [];
      this.formData.washBack = [];
      this.formData.washOther = [];

      // 移除清洗单位的验证规则
      // this.$delete(this.formRule, 'washUnit');

      // 重置上传组件状态
      this.clearUpload('uploadWashPerThird');
      this.clearUpload('uploadWashBackThird');
      this.clearUpload('uploadWashOtherThird');

      this.clearUpload('uploadWashPerSelf');
      this.clearUpload('uploadWashBackSelf');

      this.clearUpload('uploadWashPerFilter');
      this.clearUpload('uploadWashBackFilter');
    },
    //改变清洗方式
    changeWashWay(value) {
      console.log(value);
      // 清空相应的字段
      this.formData.washPer = [];
      this.formData.washBack = [];
      this.formData.washOther = [];

      // 重置上传组件状态
      this.clearUpload('uploadWashPerThird');
      this.clearUpload('uploadWashBackThird');
      this.clearUpload('uploadWashOtherThird');

      this.clearUpload('uploadWashPerSelf');
      this.clearUpload('uploadWashBackSelf');

      this.clearUpload('uploadWashPerFilter');
      this.clearUpload('uploadWashBackFilter');

      // 如果选择了第三方清洗，则添加清洗单位的验证规则
      if (value === 'FilterWash') {
        this.$set(this.formRule, 'washUnit', [{ required: true, message: '请输入清洗单位', trigger: 'blur' }]);
      } else {
        this.$delete(this.formRule, 'washUnit');
      }
    },


    handleAdd: function() {
      this.dlg.title = '新增'
      this.dlg.visible = true
      this.fileListInfo = []//清空上次的清洗前的照片
      this.localeList = []
      this.formData = {
        UploadType:'FilterWash'
      }
      this.resetRuleForm();
    },
    deleteWashInfo(row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('admin/LocaleUploadedInfo/delete/' + row.Id)
          .then(() => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.netGetMessageList()
          })
      })
    },

    handleLook: function(row) {
      console.log('row',row)
      this.dlg.title = '查看'
      this.dlg.visible = true
      this.fileListInfo = row.LocaleUploadedInfoBeforePicS//清洗前的照片（旧净化器）
      this.fileListBefore = row.LocaleUploadedInfoPicS,//用于查看的时候渲染清洗后的照片（新净化器）
      this.fileListOther = row.LocaleUploadedInfoOtherPicS,//用于查看的时候渲染清洗其他的材料
      this.formData.starDay = row.EndDate.split(' ')[0]//清洗日期
      this.formData.washUnit = row.WashName//清洗单位
      this.formData.UploadType = row.UploadType//清洗方式
      this.formData.Remark = row.Remark//清洗备注
      this.formData.LocaleName = row.LocaleName//点位名称
      // this.formData = Object.assign({}, row)
    },

    handleSubmit: function() {
      //   if (!this.changeState) {
      //     this.dlg.visible = false;
      //     return;
      //   }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              this.formData.starDay = new Date().toISOString().split('T')[0]
              // const para = Object.assign({}, this.formData)
              // para.LocaleUploadedInfoPicS = this.fileList

              console.log('用户输入的数据',this.formData)
              const para = {
                WashName:this.formData.washUnit,//清洗单位
                EndDate:this.formData.starDay,//清洗时间
                Id:0,//id 0代表的是新增 有记录的则不是0
                LocaleId:this.formData.LocaleId,
                LocaleUploadedInfoBeforePicS:this.formData.washPer,//清洗前照片washPer
                LocaleUploadedInfoOtherPicS:this.formData.washOther,//其他材料washBack
                LocaleUploadedInfoPicS:this.formData.washBack,//清洗后照片washOther
                Status:2,//提交
                UploadType:this.formData.UploadType,//清洗方式
                remark: this.formData.Remark,//备注
              }
              console.log('用户输入的数据',para)

              this.$post('admin/createLocaleUploadedInfo', para)
                .then(() => {
                  this.netGetMessageList()
                  this.dlg.visible = false
                })
                .catch(() => {})
            })
            .catch(() => {})
        }
      })
    },
    handlerClose: function() {
      //   if (this.changeState) {
      //     this.changeState = false;
      //     this.netGetMessageList();
      //   }
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.abnormal_data_page {
  .page_box {
    padding: 30px 0;
    text-align: center;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}
.single-img > img {
  width: 160px;
  height: 160px;
}
.view-img {
  width: 178px;
  height: 178px;
  margin-right: 10px;
}
.remove-img {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  transition: transform 0.3s;
  -webkit-transition: transform 0.3s;
}
.remove-img:hover {
  cursor: pointer;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}
</style>
